module.exports = __webpack_public_path__ + "img/mzc.02cd6134.png";